/**
 * Border radii — slightly softer than Chakra defaults.
 * Rounder corners = warmer, more approachable feel.
 */

export const radii = {
  none: '0',
  sm:   '6px',
  md:   '10px',
  lg:   '14px',
  xl:   '18px',
  '2xl': '24px',
  full: '9999px',
};
